<h2>Expiring Trips</h2>
<div class="filter-panel">
  <dx-date-box
    [showClearButton]="true"
    (onValueChanged)="handleChange()"
    [(value)]="startDate"
    [min]="minDate"
    [max]="endDate"
    placeholder="Start Date"></dx-date-box>
  <dx-date-box
    [showClearButton]="true"
    (onValueChanged)="handleChange()"
    [(value)]="endDate"
    [min]="startDate"
    [max]="maxDate"
    placeholder="End Date"></dx-date-box>
  <label>Expiring From:</label
  ><dx-select-box
    width="100px"
    [(value)]="expiringFrom"
    [items]="expiringFromOptions"
    displayExpr="name"
    valueExpr="value"
    (onValueChanged)="handleExpiringFromChanged()"></dx-select-box>
  <mat-checkbox [(ngModel)]="showSignatureOnFile" (ngModelChange)="handleSignatureOnFileChange()">
    Signature on file
  </mat-checkbox>
</div>

<dx-data-grid
  #grid
  class="content"
  [dataSource]="dso"
  [remoteOperations]="false"
  [columns]="columns"
  [twoWayBindingEnabled]="false"
  (onInitialized)="grid_onInitialized($event)"
  (onToolbarPreparing)="grid_onToolbarPreparing($event)">
  <dxo-editing mode="none" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false"></dxo-editing>

  <dxo-paging [pageSize]="config.get('itemsPerPage', 50)"></dxo-paging>

  <dxo-export [enabled]="true" fileName="expiring-trips-export"></dxo-export>

  <!-- Templates -->
  <ng-container *dxTemplate="let cellInfo of 'trips'">
    <div [title]="getTripsTooltip(cellInfo)" style="cursor: pointer" [class]="getTripsClass(cellInfo)">
      {{ cellInfo.value }}
    </div>
  </ng-container>
</dx-data-grid>
